/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	methods: {
		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				return this.performAction(
					this.prepareAction(baseActionKey)
				);
			}

			return utils.promise.reject();
		},
		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					var nodeIndex = self.getSelectedNodeIndex();
					var nodeData = self.getNodeData(nodeIndex);
					if(nodeData && nodeData._primaryKey && self.actions[baseActionKey]){
						self.deselectActiveNode();
						self.setClosestNodeAsReady(nodeIndex);
						return self.performAction(
							self.prepareAction(baseActionKey, nodeData._primaryKey)
						).then(function(context){
							self.refreshTrees();
							return context;
						});
					}
				}

				return utils.promise.reject();
			});

		},

		sanitizeResources: function(){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'ServiceUsers...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var index, additionalClasses;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();

				utils.forEach(Array.isArray(this.resourceData.data) ? this.resourceData.data : [this.resourceData.data], function (serviceData) {
					resources.initialized = true;

					if(serviceData.children && serviceData.children.s_services_users && serviceData.children.s_services_users.data) {
						utils.forEach(serviceData.children.s_services_users.data, function (serviceUserData) {
							if (serviceUserData.attributes && serviceUserData.children && serviceUserData.children.um_users && serviceUserData.children.um_users.data && serviceUserData.children.um_users.data.attributes) {
								var user = serviceUserData.children.um_users.data.attributes;
								var parent = '#';

								index = self.transformIDToIndex(serviceUserData.attributes[serviceUserData.primaryKey], 'serviceUser', 0, tree.length);

								additionalClasses = '';
								if(user.status && user.status === 'locked'){
									additionalClasses = 'state_preview';
								}
								else if(user.status && user.status === 'inactive'){
									additionalClasses = 'state_inactive';
								}

								tree.push({
									id: index,
									parent: parent,
									text: user.code + ' [ ' + user.status + ' | ' + serviceUserData.attributes.status + ' ]',
									type: 'serviceUser',
									state: {
										opened: true,
										disabled: false,
										selected: false
									},
									li_attr: {},
									a_attr: {
										class: additionalClasses
									}
								});
								user._primaryKey = serviceUserData.attributes.serviceUserID;
								nodes[index] = user;
							}
						});
					}

				});

				this.resourceData = resources;
			}
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component
							if(modalContentComponent && modalContentComponent.hasClass('templates_propertiesForms_serviceUserPropertiesForm')){
								await modalContentComponent.submit()
                                await options.decisionComponent.hide()
							}
							break
					}
					break

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break
					}
					break

				default:
					// TODO: ERROR;
					break
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_serviceUserPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_serviceUserPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'serviceUser';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		}
	]
};
